export type SnackbarRole = 'success' | 'warning' | 'error';

export type SnackbarDuration = 'short' | 'long' | 'fixed';

export interface SnackbarAction {
  label: string;
  callback: () => void;
}

export interface SnackbarData {
  svgIcon?: string;
  text: string;
  role?: SnackbarRole;
  /** Omit for default (`long`). `short` auto-closes in 4s without a close button. */
  duration?: SnackbarDuration;
  action?: SnackbarAction;
}

export const SNACKBAR_ROLE_ICONS: Record<SnackbarRole, string> = {
  success: 'check-filled',
  warning: 'warning-filled',
  error: 'error-filled',
};

export const SNACKBAR_DURATION_MS: Record<SnackbarDuration, number | null> = {
  short: 4000,
  long: 10000,
  fixed: null,
};

export const SNACKBAR_DEFAULT_DURATION: SnackbarDuration = 'long';

export function resolveSnackbarDurationMs(
  duration: SnackbarDuration | undefined,
): number | null {
  return SNACKBAR_DURATION_MS[duration ?? SNACKBAR_DEFAULT_DURATION];
}

export function snackbarShowsCloseButton(
  duration: SnackbarDuration | undefined,
  hasAction = false,
): boolean {
  if (hasAction) {
    return false;
  }

  return (duration ?? SNACKBAR_DEFAULT_DURATION) !== 'short';
}
